<template>
  <!-- 选择合同 -->
  <div>
    <el-form :model="searchForm" ref="searchFormRef" label-width="100px" label-suffix=":">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="老人姓名" prop="name">
            <el-input
              clearable
              v-model="searchForm.name"
              placeholder="老人姓名"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col span="18">
          <div style="float:right">
            <el-button type="primary" @click="searchBtn" size="small"> 搜索 </el-button>

            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- <el-radio-group v-model="radio"> -->
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="choice" slot-scope="scope">
        <el-radio v-model="radio" :label="scope.row" @change="radioChange()"> {{ ' ' }}</el-radio>
      </template>
    </avue-crud>
    <!-- </el-radio-group> -->
    
    <div style="text-align: right" >
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="submitContract" size="small">
        提交
      </el-button>
      <!-- <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button> -->
    </div>
  </div>
</template>

<script>
import { nursingbasicInforpage } from '@/api/nursingHome/nursingCard';

export default {
  props: ['nursinghomeId'],

  data() {
    return {
      radio: '',

      option: {
        page: true,
        height: '500',
        align: 'center',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '选择',
            prop: 'choice',
            slot: true,
          },
          {
            label: '姓名',
            prop: 'name',
          },
          {
            label: '性别',
            prop: 'sex',
            dicUrl: '/api/blade-system/dict/dictionary?code=sex',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '身份证',
            prop: 'idNumber',
          },
        ],
      },
      searchForm: {
        nursinghomeId: '',

        name: '',
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      form: {},
      data: [],
    };
  },
  created() {
    this.searchForm.nursinghomeId = this.nursinghomeId;
  },
  methods: {
    searchBtn() {
      this.page.currentPage = 1;
      this.search();
    },
    search() {
      this.radio = '';
      this.onLoad();
    },
    onLoad() {
      if (this.searchForm.nursinghomeId != '') {
        this.loading = true;

        nursingbasicInforpage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    radioChange() {
      console.log(this.radio);
    },
    //提交
    submitContract() {
      this.$emit('getData', this.radio);
    },
    searchClear() {
      this.searchForm.name =""
    },
    //获取合同类型
  },
};
</script>

<style scoped>
.btnArea {
  widows: 100%;
  text-align: center;
  margin-top: 20px;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}
.money {
  text-align: right;
}
</style>
